import {h, Fragment} from "preact"
import { useAppState, HistoryElement } from '@nosto/preact'
import { useState, useEffect } from 'preact/hooks'

import { popularSearches } from "./popularSearches"

import { defaultConfig } from '../config'

export default () => {
    const { historyItems } = useAppState()

    if (!historyItems || !historyItems.length) {
        return
    }

    const [screenWidth, setScreenWidth] = useState(window.innerWidth)
    const [form, setForm] = useState(screenWidth < 769 ? document.querySelector(".header__search-bar--mobile") : document.querySelector(".header__search-bar--desktop"))
    const [leftPosition, setLeftPosition] = useState(form?.getBoundingClientRect().x);

    useEffect(() => {
        nostojs(api => {
            api.createRecommendationRequest()
                .setElements(['ns-autocomplete-rec'])
                .loadRecommendations()
        })
    }, [])

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth)

            if (screenWidth < 769) {
                setForm(document.querySelector(".header__search-bar--mobile"))
            } else {
                setForm(document.querySelector(".header__search-bar--desktop"))
            }

            if (form) {
                setLeftPosition(form.getBoundingClientRect().x)
            }

        }

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, [screenWidth])

    return (
        <div class="ns-autocomplete history ns-absolute ns-border-box ns-my-0 ns-mx-auto" style={`left: -${leftPosition}px`}>
            <div class="ns-popular-searches-container ns-mt-2 ns-mt-sm-auto">
                <div class="ns-popular-searches-heading ns-font-medium">Popular Searches</div>
                <div class="ns-popular-searches-inner">
                    {popularSearches.map((item) => {
                        const { name, link } = item
                        return <HistoryElement query={{ query: name }}>
                            <div class="ns-product ns-d-flex flex-row ns-justify-content-between ns-clickable">
                                <div style="font-size: 12px">{name}</div>
                            </div>
                        </HistoryElement>
                    })}
                </div>
            </div>
            <div class="ns-autocomplete-recommendation">
                <div class="nosto_element" id="ns-autocomplete-rec"></div>
            </div>
        </div>
    )
}
